<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- main content -->
    <!-- Header Component -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>

    <!--  create new api config popup -->
    <v-row justify="center">
      <v-dialog v-model="createNewAPIConfigPopup" persistent max-width="700px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex">
            <span>Create New Error Configuration</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="closeCreatePopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col class="p-0" cols="12" sm="12" md="12">
                    <v-combobox v-model="api_name" :items="api_data" item-title="name"
                      item-value="id" label="Select API Name" variant="outlined" color="primary" class="ma-2"></v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="p-0" colo="6" sm="6" md="6">
                    <v-text-field v-model="error_type" item-title="name" item-value="id"
                      class="ma-2" variant="outlined" color="primary" label="Enter Error Type"></v-text-field>
                  </v-col>
                  <v-col class="p-0" colo="12" sm="6" md="6">
                    <v-autocomplete v-model="error_code" prepend-inner-icon="mdi-magnify" :items="error_items"
                      item-title="" item-value="" label="Search/ Select Error Code" variant="outlined" color="primary" multiple
                      class="ma-2"></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="p-0" cols="6" sm="6" md="6">
                    <div v-for="(number, index) in mobileNumbers" :key="index" class="ma-2">
                      <v-text-field type="text" v-model="number.mobile_number" hide-details
                        item-title="name" item-value="id" variant="outlined" maxlength="10" oninput="this.value = this.value.replace(/[^0-9]/g, '');"  color="primary" label="Mobile Number (Optional)"></v-text-field>
                    </div>
                    <a href="#" @click.prevent="addMobileNumber" style="text-decoration: underline;" class="ml-2">
                      <span>Add More +</span>
                    </a>
                  </v-col>
                  <v-col class="p-0" cols="6" sm="6" md="6">
                    <div v-for="(email, index) in emailids" :key="index" class="ma-2">
                      <v-text-field v-model="email.email" :rules="[emailRule]" hide-details
                        item-title="name" item-value="id" variant="outlined" color="primary" label="Email ID *" @keyup="checkEmailValidity"></v-text-field>
                    </div>
                    <a href="#" @click.prevent="addEmailId" class="ml-2">
                      <span>Add More +</span>
                    </a>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" lg="12" md="12" class="pb-0">
                    <label class="mb-0"><b>Enable Re-Trigger</b></label>
                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12" class="pt-0`">
                    <v-radio-group v-model="isChecked" row inline class="d-flex">
                      <v-radio label="Yes" :value="true" color="primary"> </v-radio>
                      <v-radio label="No" :value="false" color="primary"> </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                  <!-- <v-col> -->
                    <v-btn size="small" variant="outlined" color="primary" class="mr-2 text-none" @click="closeCreatePopup">Cancel</v-btn>
                    <v-btn size="small" variant="flat" color="primary" class="createnewapi text-none" @click="createNewAPI()" :disabled="!isFormValid" v-if="showSubmit">Submit</v-btn>
                    <v-btn size="small" variant="flat" color="primary" class="editapi text-none" @click="UpdateAPI()" :disabled="!isFormValid" v-else>Submit</v-btn>
                  <!-- </v-col> -->
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="successpopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon @click="successpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat"  class="mb-3" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--  Delete messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="deletepopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon @click="deletepopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span>Are you sure, you want to delete this API? </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3  text-none" @click="deleteAPI()">OK</v-btn>
            <v-btn color="primary" variant="outlined" class="mb-3 text-none" @click="deletepopup = false">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-3p" v-model="filtersPopup" persistent max-width="1224px">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-text-field v-model="filterErrorType" prepend-inner-icon="mdi-magnify" item-title="name" item-value="id"
              class="ma-2" variant="outlined" color="primary" label="Error Type" style="max-width:300px;"></v-text-field>
            <v-combobox v-model="filterErrorCode" prepend-inner-icon="mdi-magnify" :items="filterErrorItems" item-title="name"
              item-value="id" label="Error Code" variant="outlined" color="primary" class="ma-2" style="max-width:300px;"></v-combobox>

            <v-text-field v-model="filterEmailId" prepend-inner-icon="mdi-magnify" item-title="name" item-value="id"
              class="ma-2" variant="outlined" color="primary" label="Email ID" style="max-width:300px;"></v-text-field>
            <v-text-field type="number" v-model="filterMobileNumber" prepend-inner-icon="mdi-magnify" item-title="name"
              item-value="id" class="ma-2" variant="outlined" color="primary" label="Mobile Number" style="max-width:300px;"></v-text-field>

          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn small text color="normal" variant="outlined" class=" text-none" @click="cancelFilterpopup">Cancel</v-btn>
            <v-btn small variant="flat"  color="primary" class=" text-none" @click="applyFilterFunc()">Apply Filter(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- For showing Filters and Action buttons -->
    <v-card-title class="action-style mt-6 pb-0">
      <v-row class="ma-2">
        <v-col class="pb-0">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="item_search" v-no-edge-space label="Search" style="max-width: 300px;"
            variant="outlined" color="primary" v-on:keyup.enter="loadData()"></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-card-actions style="margin-bottom: 18px;">
          <v-btn size="x-large" class="mr-2 text-none" variant="flat" color="primary" @click="openDelete" :disabled="(this.selected.length == 0)">Delete</v-btn>
          <v-btn size="x-large" class="mr-2 text-none" variant="flat" color="primary" @click="EditAPIConfig" :disabled="(this.selected.length != 1)">Edit</v-btn>
          <v-btn size="x-large" class="mr-2 text-none" variant="flat" color="primary" @click="createNewAPIConfig">Create New</v-btn>
        </v-card-actions>
        <v-expansion-panels ref="filterPopupRef" class="custom-control_outlined m-0 pt-2" readonly
          style="max-width: 300px; margin-bottom: 14px; height: 52px;">
          <v-expansion-panel outlined @click="listFiltersData">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card-title>
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table :dense="true" v-model="selected" show-select disable-pagination :hide-default-footer="true"
          :headers="headers" :items="table_data" :loading="loading" fixed-header height="100%"
          loading-text="Loading Data... Please wait" class="elevation-1">
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'error_code'">
                <div v-for="code in item.error_code" :key="code">{{ code }}</div>
              </span> 
              <span v-else-if="header.key == 'email'">
                <div v-for="email in item.email" :key="email">{{ email }}</div>
              </span> 
              <span v-else-if="header.key == 'mobile_number'">
                <div v-for="number in item.mobile_number" :key="number">{{ number }}</div>
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>

          <!-- <template #[`item.error_code`]="{ item }">
            <div v-for="code in item.error_code" :key="code">{{ code }}</div>
          </template>
          <template #[`item.email`]="{ item }">
            <div v-for="email in item.email" :key="email">{{ email }}</div>
          </template>
          <template #[`item.mobile_number`]="{ item }">
            <div v-for="number in item.mobile_number" :key="number">{{ number }}</div>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>

    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
import { computed } from 'vue';
import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import { requiredUnless } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      headerText: 'Error Handling',
      alert_type: 'success',
      alert_message: '',
      alert: false,
      selected: [],
      loading: false,
      headers: [],
      table_data: [

      ],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      item_search: '',
      filtersPopup: false,
      filterErrorItems: [],
      error_code: [],
      api_name: '',
      error_type: '',
      mobileNumbers: [
        {
          mobile_number: '',
        }
      ],
      emailids: [
        {
          email: '',
        }
      ],
      filterErrorType: '',
      filterErrorCode: null,
      filterEmailId: '',
      filterMobileNumber: '',
      createNewAPIConfigPopup: false,
      successmessage: '',
      successpopup: false,
      isChecked: null,
      error_items: [],
      api_data: [],
      deletepopup: false,
      showSubmit: false,
      emailRule: (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Invalid email address',
      isAnyEmailInvalid: true,
    }
  },
  components: {
    HeaderComponent
  },
  computed: {
    isFormValid() {
      const allEmailsValid = this.emailids.every(
        (email) => this.emailRule(email.email) === true || email.email === ''
      );
      return (
        this.emailids.every((email) => email.email !== '') &&
        allEmailsValid &&
        this.error_code.length > 0 &&
        this.error_type &&
        this.api_name &&
        this.isChecked != null
      );
    },
    addMoreStyle() {
      return {
        textDecoration: 'underline',
        margin: this.isAnyEmailInvalid ? '-35px 10px' : '-20px 10px',
        position: 'absolute'
      };
    }
  },
  async created() {
    this.organization_name = this.$store.state.organization_name
    this.loadData('Overall')
    this.scrollToTop();
  },
  methods: {
    checkEmailValidity() {
      this.isAnyEmailInvalid = this.emailids && this.emailids.every(email => this.emailRule(email.email) === true);
    },
    listFiltersData(ev) {
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      this.item_search = '';
      this.filtersPopup = true;
      this.filter_date = '';
      this.filterStage = '';
      this.$httpSecured
      .get("/api/v2/api_log_configurations/filter_data")
      .then(response => {
        if (response.data) {
          this.filterErrorItems = response.data.error_codes.flat();
          this.loading = false;
          this.resetForm()
        } else {
          this.loading = false;
          this.showAlert("error", "No Data Found");
        }
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
        this.loading = false;
      });
    },
    getRequestParams(page, pageSize, filterPageNo) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (filterPageNo) {
        params["filterPageNo"] = filterPageNo
      }
      return params;
    },
    handlePageChange(value) {
      this.page = value;
      if (this.isFiltering) {
        this.filterPage = value;
        this.applyFilterFunc();
        return;
      }
      this.fetchingAPIConfigurationData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.filterPage = 1;
      if (this.isFiltering) {
        this.applyFilterFunc();
        return;
      }
      this.fetchingAPIConfigurationData();
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    cancelFilterpopup() {
      this.filtersPopup = false;
      this.filter_date = '';
      this.filterStage = '';
    },

    addMobileNumber() {
      this.mobileNumbers = [
        ...this.mobileNumbers,
        {
          mobile_number: ''
        }
      ];
      // this.mobileNumbers.push('');  // Add a new empty string to the array
    },
    addEmailId() {
      this.emailids = [
        ...this.emailids,
        {
          email: ''
        }
      ];
      // this.emailids.push('');  // Add a new empty string to the array
    },
    loadData() {
      this.loading = true;
      this.selected = []
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.filterPageNo = 1
      this.isFilteringPage = false
      this.headers = [
        { title: "API Name", key: "api_name", sortable: false },
        { title: "Error Type", key: "error_type" },
        { title: "Error Code", key: "error_code" },
        { title: "Email ID", key: "email" },
        { title: "Mobile Number", key: "mobile_number" },
      ];
      this.fetchingAPIConfigurationData();
    },
    fetchingAPIConfigurationData() {
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      );
      const requestParams = {
        page: params.page,
        per_page: params.size,
        search: this.item_search,
      };
      this.$httpSecured
        .get("/api/v2/api_log_configurations", { params: requestParams })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.api_log_configurations.map(item => ({
              ...item,
              error_code: item.error_code ? item.error_code : [],
              mobile_number: item.mobile_number ? item.mobile_number : [],
              email: item.email ? item.email : [],
            }));
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    applyFilterFunc(){
      const params = new URLSearchParams();
      params.append('page', this.page);
      params.append('per_page', this.pageSize);
      params.append('search', this.item_search);
      params.append('filter[error_code]', this.filterErrorCode);
      params.append('filter[error_type]', this.filterErrorType);
      params.append('filter[email]', this.filterEmailId);
      params.append('filter[mobile_number]', this.filterMobileNumber);

      const requestParams = params;
      this.$httpSecured
        .get("/api/v2/api_log_configurations", { params: requestParams })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.api_log_configurations.map(item => ({
              ...item,
              error_code: item.error_code ? item.error_code : [],
              mobile_number: item.mobile_number ? item.mobile_number : [],
              email: item.email ? item.email : [],
            }));
            this.filterErrorCode = null,
            this.filterErrorType = '',
            this.filterEmailId = '',
            this.filterMobileNumber = ''
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    createNewAPIConfig() {
      this.showSubmit = true;
      this.$httpSecured
        .get("/api/v2/api_log_configurations/filter_data")
        .then(response => {
          if (response.data) {
            this.api_data = response.data.api_names.flat().map((name, index) => ({ name, id: index }));
            this.error_items = response.data.error_codes.flat();
            this.filterErrorItems = response.data.error_codes.flat();
            this.createNewAPIConfigPopup = true;
            this.loading = false;
            this.resetForm();
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    EditAPIConfig() {
      this.showSubmit = false;
      const selectedItem = this.selected[0]; // Assuming only one item is selected
      alert(JSON.stringify(selectedItem))
      this.api_name = selectedItem.api_name;
      this.error_type = selectedItem.error_type;
      this.error_code = selectedItem.error_code.join(', ');
      this.mobileNumbers = selectedItem.mobile_number.map(number => ({ mobile_number: number }));
      this.emailids = selectedItem.email.map(email => ({ email: email }));
      this.isChecked = selectedItem.retrigger === true;
      this.$httpSecured
        .get("/api/v2/api_log_configurations/filter_data")
        .then(response => {
          if (response.data) {
            this.api_data = response.data.api_names.flat().map((name, index) => ({ name, id: index }));
            this.error_items = response.data.error_codes.flat();
            this.filterErrorItems = response.data.error_codes.flat();
            this.createNewAPIConfigPopup = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    UpdateAPI(){
      const item_id = this.selected[0].id
      const requestParams = {
        api_log_configuration: {
          api_name: this.api_name.name,
          error_type: this.error_type,
          error_code: this.error_code,
          mobile_number: this.mobileNumbers.map(m => m.mobile_number),
          email: this.emailids.map(e => e.email),
          retrigger: this.isChecked
        }
      };
      this.$httpSecured
        .put(`/api/v2/api_log_configurations/${item_id}`, requestParams)
        .then(response => {
          if (response.data) {
            this.createNewAPIConfigPopup = false;
            this.resetForm();
            this.successpopup = true;
            this.successmessage = response.data.data
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert('error', error.response.data.message)
          // this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    createNewAPI() {
      const requestParams = {
        api_log_configuration: {
          api_name: this.api_name.name,
          error_type: this.error_type,
          error_code: this.error_code, // Ensure error_code reflects the correct selection
          mobile_number: this.mobileNumbers.map(m => m.mobile_number),
          email: this.emailids.map(e => e.email),
          retrigger: this.isChecked
        }
      };
      this.$httpSecured
        .post(`/api/v2/api_log_configurations`, requestParams)
        .then(response => {
          if (response.data) {
            this.createNewAPIConfigPopup = false;
            this.resetForm();
            this.successpopup = true;
            this.successmessage = response.data.data
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert('error', error.response.data.message)
          // this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    resetForm() {
      this.emailids = [{email: ''}];
      this.mobileNumbers = [{mobile_number: ''}];
      this.api_name = '';
      this.error_code = [];
      this.error_type = '';
    },
    closeCreatePopup() {
      this.createNewAPIConfigPopup = false;
      this.resetForm();
    },
    afterClickOkLoadData() {
      this.successpopup = false;
      this.successmessage = ''
      this.selected = [];
      this.loadData();
    },
    openDelete() {
      this.deletepopup = true;
    },
    deleteAPI() {
      this.$httpSecured
        .delete(`api/v2/api_log_configurations/${this.selected[0].id}`)
        .then(response => {
          if (response.data) {
            this.deletepopup = false;
            this.successmessage = response.data.data;
            this.successpopup = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
  },
}
</script>
<style scoped>
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-color: rgba(0,0,0,.42);
    border-style: solid;
  }
  .custom-control_outlined button:focus {
    outline: none;
  }
  .v-input--radio-group.v-input--radio-group--row .v-radio{
    margin-right: 225px;
  }
  .v-dialog:has(.filter-3p){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 270px) !important;
  }
  .filter_ui{
    margin-left: 20px !important;
    margin-top: 12px !important;
  }
</style>